import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CommonAppModule } from '../../common/common-app.module';
import { UiModule } from '../../ui/ui.module';

import { MessageComponent } from './message/message.component';
import { MessagesComponent } from './messages.component';

@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		RouterModule,
		UiModule,
	],
	declarations: [
		MessagesComponent,
		MessageComponent,
	],
	exports: [
		MessagesComponent,
		MessageComponent,
	],
})

export class MessagesModule { }
